import React, { useState } from 'react';
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Grid,
  Snackbar,
  IconButton,
} from '@mui/material';
import '../styles/productDenomination.css';
import CloseIcon from '@mui/icons-material/Close';
import DenominationTable from './DenominationTable';
import RangeDenomination from './RangeDenomination';
import Payment from '../payment/Payment';
import { useSelector } from 'react-redux';
import UserDetailPayment from '../payment/paymentUtils/UserDetailPayment';
import { useAuth } from '../../../hooks/contexts/AuthContext';
import TermsAndCondition from '../payment/paymentUtils/TermsAndCondition';
export default function ProductDenomination() {
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
  });
  const { isLoggedIn } = useAuth();

  const handleClose = () => {
    setSnackbar({ open: false, message: '' });
  };

  return (
    <Grid container sx={{ justifyContent: 'space-between', }}>
      <Grid item xs={12} md={5.8}>
        {PRODUCTDETAILS.rangeDenomination && <RangeDenomination />}

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={2000}
          open={snackbar.open}
          onClose={handleClose}
          message={snackbar.message}
          action={
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          }
          sx={{
            '.MuiSnackbarContent-root': {
              backgroundColor: 'error.main',
              fontSize: '13.5px',
              fontWeight: 400,
            },
          }}
        />

        <TableContainer
          sx={{
            mt: '-15px',
            position: 'relative',
          }}
        >
          <Table
            stickyHeader
            sx={{
              width: '100%',
              minWidth: '100%',
              maxWidth: '100%',
              minHeight: '30px',
              borderCollapse: 'separate',
              borderSpacing: '0 15px',
            }}
          >
            <TableHead
              sx={{
                '& .MuiTableCell-head': {
                  background: 'linear-gradient(180deg, #0B4AA2 0%, #0A3C84 100%)',
                  textTransform: 'capitalize',
                  color: 'white.main',
                  fontWeight: 500,
                  fontSize: '1.1rem',
                  px: { xs: 0 },
                  height: 36,
                  py: 0.5,
                  lineHeight: 1.2,
                },
                '& .MuiTableRow-root': {
                  overflow: 'hidden', // to clip rounded corners properly
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                },
                '& .MuiTableCell-head:first-of-type': {
                  borderTopLeftRadius: 8,
                },
                '& .MuiTableCell-head:last-of-type': {
                  borderTopRightRadius: 8,
                },
              }}
            >
              <TableRow>
                <TableCell align="center">Amount</TableCell>
                <TableCell align="center">{PRODUCTDETAILS.productType}</TableCell>
                <TableCell align="center">Quantity</TableCell>
                <TableCell align="center">Total</TableCell>
                {PRODUCTDETAILS.rangeDenomination && <TableCell align="center">Action</TableCell>}
              </TableRow>
            </TableHead>

            <TableBody >
              <DenominationTable setSnackbar={setSnackbar} handleClose={handleClose} />
            </TableBody>
          </Table>
        </TableContainer>

        {isLoggedIn && <UserDetailPayment />}

        <TermsAndCondition />
      </Grid>

      <Grid item xs={12} md={5.8}>
        <Payment />
      </Grid>
    </Grid >
  );
}
